import { Nav, Navbar } from 'react-bootstrap';

import AnimatedToggle from './AnimatedToggle';
import PropTypes from 'prop-types';
import React from 'react';
import { signOut } from '../utils/auth';
import styled from 'styled-components';

const StyledNavbarToggle = styled(Navbar.Toggle)`
  border: none;
`;

const MainNav = ({ navigate }) => (
  <>
    {/* eslint-disable-next-line react/no-children-prop */}
    <StyledNavbarToggle
      aria-controls="responsive-navbar-nav"
      children={AnimatedToggle}
    />
    <Navbar.Collapse id="responsive-navbar-nav" className="pt-3">
      <Nav className="ml-auto pb-4">
        <Nav.Link href="/net-zero">Net-Zero</Nav.Link>
        <Nav.Link href="/download">Download app</Nav.Link>
        <Nav.Link href="/account">Account</Nav.Link>
        <Nav.Link href="/" onClick={() => signOut(navigate)}>
          Sign Out
        </Nav.Link>
      </Nav>
    </Navbar.Collapse>
  </>
);

MainNav.propTypes = {
  navigate: PropTypes.func,
};

export default MainNav;
